<template>
  <div style="position:relative;height:100vh;overflow:hidden;">

    <!-- 悬浮汉堡按钮 -->
    <div @click="toggleMenu" style="position:fixed;top:15px;left:15px;z-index:99999;width:40px;height:40px;background:rgba(0,0,0,0.45);border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,0.3);">
      <span style="display:block;width:18px;height:2px;background:#fff;border-radius:2px;"></span>
      <span style="display:block;width:18px;height:2px;background:#fff;border-radius:2px;"></span>
      <span style="display:block;width:18px;height:2px;background:#fff;border-radius:2px;"></span>
    </div>

    <!-- 菜单弹出层 -->
    <div v-if="menuShow" @click.self="menuShow=false" style="position:fixed;top:0;left:0;width:100%;height:100%;z-index:99998;background:rgba(0,0,0,0.4);">
      <div style="position:absolute;top:65px;left:15px;background:#fff;border-radius:12px;padding:8px 0;min-width:140px;box-shadow:0 4px 16px rgba(0,0,0,0.2);">
        <div @click="goBack" style="display:flex;align-items:center;padding:14px 20px;font-size:15px;color:#333;cursor:pointer;border-bottom:1px solid #f5f5f5;">
          <span style="margin-right:10px;font-size:18px;">🏠</span> 返回大厅
        </div>
        <div @click="menuShow=false" style="display:flex;align-items:center;padding:14px 20px;font-size:15px;color:#666;cursor:pointer;">
          <span style="margin-right:10px;font-size:18px;">✕</span> 继续游戏
        </div>
      </div>
    </div>

    <!-- iframe区域 - 全屏 -->
    <div style="position:absolute;top:0;left:0;right:0;bottom:0;">
      <iframe v-if="url" style="height:100%;width:100%;border:none;" ref="iframe" :src="url" scrolling="auto" frameborder="0" id="iframe"></iframe>
      <iframe v-if="gohtml" style="height:100%;width:100%;border:none;" ref="iframe" :srcdoc="gohtml" scrolling="auto" frameborder="0" id="iframe"></iframe>
    </div>

  </div>
</template>
<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
      gohtml: null,
      menuShow: false,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.dailiD == 1) { that.getAgentLoginUrl(); return; }
    if (query.dailiD == 2) { that.getservicerurl(); return; }
    if (query.app) {
      var downloadUrl = that.$store.state.appInfo.ios_download_url || '';
      if (downloadUrl) { window.location.href = downloadUrl; }
      return;
    }
    if (query.name) { that.goGamePage(query.name, query.type, query.code); return; }
  },
  methods: {
    toggleMenu() {
      this.menuShow = !this.menuShow;
    },
    goBack() {
      this.menuShow = false;
      this.$router.push({ path: '/' });
    },
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code == 200) { that.url = res.data.url; }
      });
    },
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code == 200) { that.url = res.data.url; }
      });
    },
    goGamePage(name, type, code) {
      let that = this;
      this.$parent.showTost(1, this.$langmsg.is_loding);
      that.$apiFun.post('/api/getGameUrl', { plat_name: name, game_type: type, game_code: code || 0, is_mobile_url: 1 })
        .then(res => {
          if (!res.code) { that.gohtml = res; }
          else {
            if (res.code != 200) { that.showTost(0, res.message); }
            if (res.code == 200) { that.url = res.data.url; }
          }
        }).catch(res => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mode/gamePage.vue